import { motion } from "framer-motion";
import { CalendarCheck, ShieldAlert, Activity, Trash2 } from "lucide-react";
import { StatusBadge, timeAgo } from "@/components/common";

const META = {
  absensi: { icon: CalendarCheck, color: "text-emerald-600 bg-emerald-100" },
  pelanggaran: { icon: ShieldAlert, color: "text-rose-600 bg-rose-100" },
};

export default function ActivityFeed({ activities, showSantri = true, onDelete }) {
  if (!activities?.length) {
    return (
      <div className="glass rounded-2xl p-10 text-center">
        <Activity className="h-8 w-8 mx-auto text-emerald-400 mb-3" />
        <p className="text-slate-500">Belum ada aktivitas tercatat.</p>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="activity-feed">
      {activities.map((a, i) => {
        const meta = META[a.tipe] || META.absensi;
        const Icon = meta.icon;
        return (
          <motion.div key={a.id} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
            transition={{ delay: Math.min(i * 0.04, 0.4) }} data-testid={`activity-item-${i}`}
            className="glass glass-hover rounded-2xl p-4 flex items-start gap-4">
            <div className={`h-10 w-10 shrink-0 rounded-xl flex items-center justify-center ${meta.color}`}>
              <Icon className="h-5 w-5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <p className="font-semibold text-emerald-950 truncate">{a.judul}</p>
              <div className="flex items-center gap-2 shrink-0">
                <StatusBadge status={a.status} />
                {onDelete && <button data-testid={`activity-delete-${i}`} onClick={() => onDelete(a)} className="text-rose-400 hover:text-rose-600"><Trash2 className="h-4 w-4" /></button>}
              </div>
              </div>
              <p className="text-sm text-slate-500 mt-0.5">{a.deskripsi}</p>
              <div className="flex items-center gap-2 mt-1.5 text-xs text-slate-400 flex-wrap">
                {showSantri && <><span className="font-medium text-emerald-700">{a.santri_nama}</span><span>·</span></>}
                <span>oleh {a.oleh}</span><span>·</span><span>{timeAgo(a.created_at)}</span>
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
